<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
     <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
             <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
               
                <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date
                            </label>
                            <Field name="dateInventaire" type="date"  :value="getCurrentDate()"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="dateInventaire" class="text-danger"/>
                            </div>
                        </div>

                        <!-- <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Montant
                            </label>
                            <Field name="montant" type="text" v-model="montantTotal"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="montant" class="text-danger"/>
                            </div>
                        </div> -->
    
                        <!-- <div class="col-md-6">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                    Fournisseur <span class="text-danger">*</span>
                                </label>
                                <Field name="client" v-slot="{ field }">
                                    <Multiselect
                                    :options="clientOptions"
                                    :searchable="true"
                                    track-by="label"
                                    label="label"
                                    v-model = "field.value"
                                    v-bind = "field"
                                    placeholder="Sélectionnez le client"
                                    />
                                </Field>
                                <ErrorMessage name="client" class="text-danger"/>
                            </div>
                        </div> -->

                        <div class="col-md-12">
                            <div class="card" style="padding:0px !important;">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h5 class="card-title mb-0">magasins</h5>
                                    <!-- <button 
                                        type="button"
                                        class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                        @click="addApproMag"
                                    >
                                        + Magasin
                                    </button> -->
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                    <table class="table w-100">
                                        <tbody style="width: 100% !important;">
                                            <tr v-for="(mg, index) in approMags" :key="index">
                                               
                                                <td style="margin-bottom: 5px !important;width: 100% !important;">
                                                    <Field :name="'mg_'+index" v-model="mg.magasin"  v-slot="{ field }" style="min-width: 100px !important;">
                                                        <Multiselect
                                                            v-model = "field.value"
                                                            v-bind = "field"
                                                            :options="getFilteredOptions(index)"
                                                            :searchable="true"
                                                            placeholder="Rechercher un magasin"
                                                            noResultText= "Aucun enregistrement trouvé"
                                                            noOptionsText="Tapez au moins deux caractères" />
                                                    </Field>
                                                    <ErrorMessage :name="'mg_'+index" class="text-danger"/>

                                                    <div style="clear:both"></div> <br>
                                                    <!-- PRODUITS CONDITIONNEMENT  -->
                                                    <div class="col-md-12">
                                                        <div class="card" style="padding:0px !important;">
                                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                                <h5 class="card-title mb-0">produit conditionnement</h5>
                                                                <!-- <button 
                                                                    type="button"
                                                                    class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                                                    @click="addApproMagProdCond(index)"
                                                                >
                                                                    + produit conditionnement
                                                                </button> -->
                                                            </div>
                                                            <div class="card-body">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Produit</th>
                                                                            <th>Qte Logique</th>
                                                                            <th>Qte Physique</th>
                                                                            <th>Ecart</th>
                                                                            <th>Observation</th>
                                                                            <th>Regu?</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(pro, pIndex) in produitCondInventaires" :key="pIndex">
                                                                            <td style="margin-bottom: 5px !important;min-width: 300px !important;">
                                                                            <Field :name="'pro_pro'+pIndex" v-model="pro.produitConditionnement"  v-slot="{ field }" style="min-width: 100px !important;">
                                                                                <Multiselect
                                                                                    v-model = "field.value"
                                                                                    v-bind = "field"
                                                                                    :options="getFilteredOptionsPC(index,pIndex)"
                                                                                    :searchable="true"
                                                                                    placeholder="Rechercher un produit"
                                                                                    noResultText= "Aucun enregistrement trouvé"
                                                                                    noOptionsText="Tapez au moins deux caractères" />
                                                                            </Field>
                                                                            <!-- <ErrorMessage :name="'pro_'+index+'_'+pIndex" class="text-danger"/> -->
                                                                            <span class="invalid-feedback" v-if="valideteRowElement(pro.produitConditionnement)"></span>
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_qteLog'+pIndex" type="text" v-model="pro.qteLog" readonly="true"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                                                <!-- <ErrorMessage :name="'pro_qteLog'+pIndex" class="text-danger"/> -->
                                                                                <div class="invalid-feedback" v-if="valideteRowElement(pro.qteLog)">
                                                                                    La quantité logiciel est obligatoire
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_qtePhy'+pIndex" type="text" v-model="pro.qtePhy"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                                                <!-- <ErrorMessage :name="'pro_qtePhy'+pIndex" class="text-danger"/> -->
                                                                                <div class="invalid-feedback" v-if="valideteRowElement(pro.qtePhy)">
                                                                                    La quantité physique est obligatoire
                                                                                </div>
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_ecart'+pIndex" type="text" v-model="pro.ecart"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0" readonly="true"/>
                                                                                <ErrorMessage :name="'pro_ecart'+pIndex" class="text-danger"/>
                                                                                <!-- <div class="invalid-feedback" v-if="valideteRowElement(pro.qtePhy)">
                                                                                    L'écart est obligatoire
                                                                                </div> -->
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_observation'+pIndex" type="text" v-model="pro.observation"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder=""/>
                                                                                <ErrorMessage :name="'pro_observation'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <!-- <Field :name="'pro_estRegularise'+pIndex" type="checkbox" v-model="pro.estRegularise"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/> -->
                                                                                <Field :name="'pro_estRegularise'+pIndex" type="checkbox" v-model="pro.estRegularise" 
                                                                                :value="true" :unchecked-value="false" class="form-check-input shadow-none" />

                                                                                <ErrorMessage :name="'pro_estRegularise'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-sm btn-outline-danger"
                                                                                    @click="removeLigne(pIndex)"
                                                                                >
                                                                                    x
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="card-footer">
                                                                <button 
                                                                    type="button"
                                                                    class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                                                    :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                                                                    @click="AddProduitCondInventaire(index)"
                                                                >
                                                                    + produit conditionnement
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </td>
                                                    
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="clear:both;"></div><br>

                       

                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit"
                            >
                                Enregistrer
                            </button>
                            <router-link to="/inventaires" 
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>
                </div>
            </Form>
     </div>
    </div>
   
   
   </template>
   
   <script lang="ts">
   import { defineComponent, onMounted, reactive, ref, watch, toRaw } from "vue";
   import { Form, Field, ErrorMessage } from "vee-validate";
   import { error, success, showModal, hideModal, monSwal } from "../../utils/utils";
   import { useRoute, useRouter } from "vue-router";
   import ApiService from "../../services/ApiService";
   import { ProdCondVente } from "../../models/ProdCondVente";
   import * as Yup from "yup";
   import Multiselect from '@vueform/multiselect';
import { Approvisionnement } from "@/models/Approvisionnement";
import { Inventaire } from "@/models/Inventaire";
   
   export default defineComponent({
     name: "AddInventaire",
     components: {
       Form,
       Field,
       ErrorMessage,
       Multiselect
     },
     
     setup: (props, { emit }) => {
       const elementSchema = Yup.object().shape({
         dateInventaire: Yup.string().required("Le client est obligatoire"),
       });
   
        const elementForm = ref<Inventaire | null>(null);
        const router = useRouter();
   
        // const empty = ref("<p><br></p>")magasinOptions
        const produitcondOptions = ref([]);
        const magasinOptions = ref([]);
        const isUPDATE = ref(false);
        const isDisable = ref(false);
        const btntext = ref("Ajouter");
        const title = ref("Ajouter un inventaire");
        
        const approMagSave = ref<any[]>([]);
        const produitCondInventaireSave = ref<any[]>([]);
        const montantTotal = ref(0);
        const total = ref(0);
   
  

        const approMags = reactive([{
            magasin: null,
            approMagProdConds: reactive([{
                produitConditionnement: null,
                prixAchat: null,
                totalLigne: 0,
                qteAppro: null
            }])
        }]);

        const produitCondInventaires = reactive([{
            produitConditionnement: null,
            qteLog: null as number | null,
            qtePhy: null as number | null,
            ecart: null as number | null,
            estRegularise: false,
            observation: null
        }]);


        const btnTitle = async () => {
            if (isUPDATE.value) {
            title.value = "Modifier l'inventaire";
            btntext.value = "Modifier";
            }else{
            title.value = "Ajouter un inventaire";
            btntext.value = "Ajouter";
            }
        }

        watch(() => produitCondInventaires.map((pc, index) => ({produitCondInventaire: pc.produitConditionnement , index})), (newValue) => {
            newValue.forEach(({ produitCondInventaire, index }) => {
                if(produitCondInventaires[index].produitConditionnement){
                    let qteLo: any = typeof produitCondInventaire === 'string' ? (produitCondInventaire as string).split('-')[1] : 0;
                    produitCondInventaires[index].qteLog = qteLo;
                    produitCondInventaires[index].ecart = qteLo - (produitCondInventaires[index].qtePhy ?? 0);
                }
            });
        });

        watch(() => produitCondInventaires.map((pc, index) => ({qtePhy: pc.qtePhy, index})), (newValue) => {
            newValue.forEach(({ qtePhy, index }) => {
                produitCondInventaires[index].ecart = 
                    (produitCondInventaires[index].qteLog ?? 0) - (produitCondInventaires[index].qtePhy ?? 0);
            });
        });


        //un watch sur qteAppro et prixAchat pour calculer le total de la ligne
        const watchelements = () => {
            // produitCondInventaires.forEach((mg, index) => {
            //     mg.approMagProdConds.forEach((cond, pIndex) => {
            //         watch(() => [cond.prixAchat, cond.qteAppro],
            //             ([newPrixAchat, newQteAppro]) => {
            //                 cond.totalLigne = (newPrixAchat ?? 0) * (newQteAppro ?? 0);
            //                 updateTotal();
            //             }
            //         );
            //     });
            // });
        };
        watchelements();

    

        const addApproMag = () => {
            approMags.push({
                magasin: null,
                approMagProdConds: reactive([])
            });
        };

        const AddProduitCondInventaire = (index) => {
            produitCondInventaires.push({
                produitConditionnement: null,
                qteLog: null,
                qtePhy: null,
                ecart: null,
                estRegularise: false,
                observation: null
            });
        };

        const addApproMagProdCond = (index) => {
            approMags[index].approMagProdConds.push({
                produitConditionnement: null,
                prixAchat: null,
                totalLigne: 0,
                qteAppro: null
            });
            watchelements();
            console.log("Approvisionnement", toRaw(approMags));
        };

        const updateTotal = () => {
            montantTotal.value = approMags.reduce((total, mg) => {
                return total + mg.approMagProdConds.reduce((subTotal, cond) => {
                return subTotal + ((cond.prixAchat ?? 0) * (cond.qteAppro ?? 0));
                }, 0);
            }, 0);
        };

        const removeApproMag = (index) => {
            approMags.splice(index, 1);
        };

        // const removeLigne = (index, pIndex) => {
        //     approMags[index].approMagProdConds.splice(pIndex, 1);
        // };
         const removeLigne = (pIndex) => {
            produitCondInventaires.splice(pIndex, 1);
        };

         
   
        onMounted(()=> {
            fetchMagasin();
            fetchProduit();
        })
   
        const getCurrentDate = () => {
             const today = new Date();
             const day = String(today.getDate()).padStart(2, '0');
             const month = String(today.getMonth() + 1).padStart(2, '0');
             const year = today.getFullYear();
             return `${year}-${month}-${day}`;
        }

        const getFilteredOptions = (index) => {
            const selectedOptions = approMags.map(c => c.magasin);
            return magasinOptions.value.filter((option: any) => {
                return !selectedOptions.includes(option.value) || option.value === approMags[index].magasin;
            });
        };

        const getFilteredOptionsPC = (indexm, indexpc) => {
            const selectedOptionspc = approMags[indexm].approMagProdConds.map((c: any) => c.produitConditionnement?.split('-')[0]);
            //console.log('yesyes', selectedOptionspc);
            return produitcondOptions.value.filter((option : any) => {
                option = option.value.split('-')[0];
                return !selectedOptionspc.includes(option) || option === approMags[indexm].approMagProdConds[indexpc].produitConditionnement;
            });
        };
   
        const fetchMagasin = async () => {
            try {
                const response = await ApiService.get('/magasins?limit=-1&');
                const data = response.data.data.data;
                magasinOptions.value = data.map((mag) => ({
                    value: mag.id,
                    label: mag.libelle,
                }));
            } catch (error) {
                //
            }
        };

        const fetchProduit = async () => {
            ApiService.get("/produitConditionnements?limit=-1&")
            .then(({ data }) => {
            produitcondOptions.value = data.data.data.map((p) => {
                return { 
                    value: p.id+'-'+p.qteStock,
                    label: p.nomComplet +' [ '+ p.conditionnement.code +' ]',
                }
            });
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
        };



        watch(
            produitCondInventaires,
            (newValue) => {
                isDisable.value =
                newValue.some(
                    (el) =>
                    valideteRowElement(el.produitConditionnement) 
                    // valideteRowElement(el.qteLog)
                    // valideteRowElement(el.qtePhy)
                    // valideteRowElement(el.ecart) 
                    // valideteRowElement(el.estRegularise) ||
                    // valideteRowElement(el.observation)
                );
            },
            { deep: true },
            
        );

        const valideteRowElement = (e) => {
            if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
                return true;
            } else {
                return false;
            }
        };

   
       const showA = ref(false)
       const show = ref("0")
   
       const addElement = async (values: any, elementForm) => {
            console.log("test test");
            // Supprimer dynamiquement tous les champs liés aux conditionnements
            Object.keys(values).forEach(key => {
                if (key.startsWith('mg_') || key.startsWith('pro_')) {
                    delete values[key];
                }
            });

            // approMagSave.value = approMags.map((pro) => {
            //     const p = { ...pro }; 
            //     return p;
            // });

            produitCondInventaireSave.value = produitCondInventaires.map((pro) => {
                const p = { ...pro }; 
                return p;
            });

            // ici produit n'est rien d'aute que produit conditionnement vente
            values.produitCondInventaires = produitCondInventaireSave.value;

            values = values as Inventaire;
            console.log("values", values);
            console.log("appr", approMags);

            const result = await monSwal(
                "Vous êtes sur le point d'enregistrer un inventaire. Êtes-vous sûr ?",
                undefined,
                "btn btn-primary",
                undefined,
                undefined,
            );

            if(result){
                if(isUPDATE.value){
                    ApiService.put("/approvisionnement/"+values.id,values)
                    .then(({ data }) => {
                        if(data.code == 200) { 
                            success(data.message);
                            elementForm.resetForm();
                            isUPDATE.value=false;
                            btnTitle();
                        }
                    })
                    .catch(({ response }) => {
                        error(response.data.message);
                    });
                }else{

                    values.montantSansEpargne = total.value;
                    console.log("form", values);
                    ApiService.post("/inventaire",values)
                    .then(({ data }) => {
                        if(data.code == 201) { 
                            success(data.message);
                            router.push('/inventaires');
                            // elementForm.resetForm();
                        }
                    })
                    .catch(({ response }) => {
                        error(response.data.message);
                    });
                }
            }
       };
   
     
   
   
       return { 
            addElement,
            elementSchema,
            magasinOptions,
            produitcondOptions,
            getCurrentDate,
            btnTitle,
            addApproMag,
            AddProduitCondInventaire,
            addApproMagProdCond,
            removeApproMag,
            approMags,
            produitCondInventaires,
            montantTotal,
            getFilteredOptions,
            getFilteredOptionsPC,
            removeLigne,
            valideteRowElement,
            isDisable,
            // updateTotal,
            // montantTotal,
            // produitConds
       };
     },
   });
   </script>
   
   <style scoped>
    .table-responsive {
        width: 100%;
    }
    .table {
        width: 100%;
    }
     table tbody td {
       padding-left: 0px !important;
     }
     .table > :not(caption) > * > * {
        padding-left: 0px !important;
     }
     .w-100 {
        width: 100% !important;
     }
   </style>
   
   